const UPDATE_YAXISINTERVAL = 'UPDATE_YAXISINTERVAL';
const UPDATE_YAXISMOBILE_ENABLED = 'UPDATE_YAXISMOBILE_ENABLED';
const UPDATE_LOG_SCALE = 'UPDATE_LOG_SCALE';
const UPDATE_MOBILEYAXISINTERVAL = 'UPDATE_MOBILEYAXISINTERVAL';
const UPDATE_XAXISINTERVAL = 'UPDATE_XAXISINTERVAL';
const UPDATE_MOBILE_XAXISINTERVAL = 'UPDATE_MOBILE_XAXISINTERVAL';
const UPDATE_MOBILE_XAXISINTERVAL_DIFF_THAN_DESKTOP =
  'UPDATE_MOBILE_XAXISINTERVAL_DIFF_THAN_DESKTOP';
const MUST_RENDER_FALSE = 'MUST_RENDER_FALSE';
const UPDATE_MAJOR_TICKS_ARTICLE = 'UPDATE_MAJOR_TICKS_ARTICLE';
const UPDATE_MINOR_TICKS_ARTICLE = 'UPDATE_MINOR_TICKS_ARTICLE';
const UPDATE_MAJOR_TICKS_PRINT = 'UPDATE_MAJOR_TICKS_PRINT';
const UPDATE_MINOR_TICKS_PRINT = 'UPDATE_MINOR_TICKS_PRINT';
const UPDATE_MAJOR_TICKS_PROMO = 'UPDATE_MAJOR_TICKS_PROMO';
const UPDATE_MINOR_TICKS_PROMO = 'UPDATE_MINOR_TICKS_PROMO';
const UPDATE_HIDDEN_CATEGORIES_ARTICLE = 'UPDATE_HIDDEN_CATEGORIES_ARTICLE';
const UPDATE_HIDDEN_CATEGORIES_PRINT = 'UPDATE_HIDDEN_CATEGORIES_PRINT';
const UPDATE_HIDDEN_CATEGORIES_PROMO = 'UPDATE_HIDDEN_CATEGORIES_PROMO';
const SHOW_MINOR_LABELS = 'SHOW_MINOR_LABELS';
const UPDATE_ALLOW_DECIMALS = 'UPDATE_ALLOW_DECIMALS';
const UPDATE_QUARTERLY_RESULTS = 'UPDATE_QUARTERLY_RESULTS';

function updateYAxisMobileEnabled(payload) {
  return { type: UPDATE_YAXISMOBILE_ENABLED, payload };
}

function mustRenderFalse(payload) {
  return { type: MUST_RENDER_FALSE, payload };
}

function updateMobileXAxisIntervalDiffThanDesktop(payload) {
  return { type: UPDATE_MOBILE_XAXISINTERVAL_DIFF_THAN_DESKTOP, payload };
}

function updateYAxisInterval(payload) {
  return { type: UPDATE_YAXISINTERVAL, payload };
}

function updateMobileYAxisInterval(payload) {
  return { type: UPDATE_MOBILEYAXISINTERVAL, payload };
}

function updateLogScale(value) {
  return { type: UPDATE_LOG_SCALE, payload: value };
}

function updateXAxisInterval(payload) {
  return { type: UPDATE_XAXISINTERVAL, payload };
}

function updateMobileXAxisInterval(payload) {
  return { type: UPDATE_MOBILE_XAXISINTERVAL, payload };
}

function updateMajorTicksArticle(payload) {
  return { type: UPDATE_MAJOR_TICKS_ARTICLE, payload };
}

function updateMinorTicksArticle(payload) {
  return { type: UPDATE_MINOR_TICKS_ARTICLE, payload };
}

function updateMajorTicksPrint(payload) {
  return { type: UPDATE_MAJOR_TICKS_PRINT, payload };
}

function updateMinorTicksPrint(payload) {
  return { type: UPDATE_MINOR_TICKS_PRINT, payload };
}

function updateMajorTicksPromo(payload) {
  return { type: UPDATE_MAJOR_TICKS_PROMO, payload };
}

function updateMinorTicksPromo(payload) {
  return { type: UPDATE_MINOR_TICKS_PROMO, payload };
}

function updateHiddenCategoriesArticle(payload) {
  return { type: UPDATE_HIDDEN_CATEGORIES_ARTICLE, payload };
}

function updateHiddenCategoriesPrint(payload) {
  return { type: UPDATE_HIDDEN_CATEGORIES_PRINT, payload };
}

function updateHiddenCategoriesPromo(payload) {
  return { type: UPDATE_HIDDEN_CATEGORIES_PROMO, payload };
}

function showMinorLabels(payload) {
  return { type: SHOW_MINOR_LABELS, payload };
}

function updateAllowDecimals(payload) {
  return { type: UPDATE_ALLOW_DECIMALS, payload };
}

function updateQuarterlyResults(value) {
  return { type: UPDATE_QUARTERLY_RESULTS, payload: value };
}

export {
  UPDATE_YAXISINTERVAL,
  UPDATE_YAXISMOBILE_ENABLED,
  UPDATE_MOBILEYAXISINTERVAL,
  UPDATE_XAXISINTERVAL,
  UPDATE_MOBILE_XAXISINTERVAL,
  UPDATE_MOBILE_XAXISINTERVAL_DIFF_THAN_DESKTOP,
  MUST_RENDER_FALSE,
  UPDATE_MAJOR_TICKS_ARTICLE,
  UPDATE_MINOR_TICKS_ARTICLE,
  UPDATE_MAJOR_TICKS_PRINT,
  UPDATE_MINOR_TICKS_PRINT,
  UPDATE_MAJOR_TICKS_PROMO,
  UPDATE_MINOR_TICKS_PROMO,
  UPDATE_HIDDEN_CATEGORIES_ARTICLE,
  UPDATE_HIDDEN_CATEGORIES_PRINT,
  UPDATE_HIDDEN_CATEGORIES_PROMO,
  SHOW_MINOR_LABELS,
  UPDATE_ALLOW_DECIMALS,
  UPDATE_QUARTERLY_RESULTS,
  UPDATE_LOG_SCALE,
  updateYAxisMobileEnabled,
  mustRenderFalse,
  updateMobileXAxisIntervalDiffThanDesktop,
  updateYAxisInterval,
  updateMobileYAxisInterval,
  updateXAxisInterval,
  updateMobileXAxisInterval,
  updateMajorTicksArticle,
  updateMinorTicksArticle,
  updateMajorTicksPrint,
  updateMinorTicksPrint,
  updateMajorTicksPromo,
  updateMinorTicksPromo,
  updateHiddenCategoriesArticle,
  updateHiddenCategoriesPrint,
  updateHiddenCategoriesPromo,
  showMinorLabels,
  updateAllowDecimals,
  updateQuarterlyResults,
  updateLogScale,
};
